/**
 * admin_push_test_controller.js — identifier "admin-push-test".
 *
 * The Send Test Notification button on admin PWA Management. POSTs to the
 * admin push-diagnostics route and reports what the server says it addressed.
 *
 * Deliberately does NOT render the notification itself. The point of the
 * button is to prove the real delivery path, so the toast the operator sees
 * has to arrive over Mercure the way a live signup's would; announcing it from
 * this handler would make a broken path look healthy. What this shows instead
 * is REACH — how many admins and registered devices the fan-out addressed —
 * because dispatch is fire-and-forget on a server thread and no response can
 * honestly claim delivery.
 *
 * Its business-side twin is sendTestPush in settings_controller.js, which is a
 * call-fn because it lives among that controller's other settings actions.
 * This one is element-scoped: it is the only behaviour on this card, and an
 * element-scoped controller is the documented default.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  send(event) {
    if (event) event.preventDefault();
    const button = this.element;
    button.disabled = true;

    window
      .api(this.urlValue, {
        method: "POST",
        headers: { Accept: "application/json" },
        notifyError: false,
      })
      .then((data) => {
        const message = (data && data.message) || "Test notification sent";
        window.showNotification(
          message,
          data && data.success ? "success" : "warning",
        );
      })
      .catch((err) => {
        const message =
          err && err.message ? err.message : "Error sending test notification";
        console.error("admin test push failed:", err);
        window.showNotification(message, "error");
      })
      .finally(() => {
        button.disabled = false;
      });
  }
}
